import { render, staticRenderFns } from "./BuildingSocietyDetails.vue?vue&type=template&id=c604da48&scoped=true&"
import script from "./BuildingSocietyDetails.vue?vue&type=script&lang=js&"
export * from "./BuildingSocietyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c604da48",
  null
  
)

export default component.exports